"use strict";

angular.module('PatientApp').directive('modal', function (OverlayService) {
  return {
    // only <modal>...</modal> allowed
    restrict: 'E',
    scope: {
      show: '=',
      whenClose: '&',
      canClose: '='
    },
    // replace the outerHTML with our generated content
    replace: true,
    // insert the innerHTML into our template wrapper
    transclude: true,
    link: function link($scope) {
      var _showing = false,
          _overlayKey = null,
          _overlayClicked = function _overlayClicked() {
        if ($scope.canClose !== false) {
          $scope.hideModal();
        }
      },
          _open = function _open() {
        _showing = true;
        OverlayService.show(_overlayKey, _overlayClicked).then(function (key) {
          _overlayKey = key;
        });
      };

      $scope.hideModal = function () {
        $scope.show = false;

        if (_overlayKey) {
          OverlayService.hide(_overlayKey);
        }

        $scope.whenClose();
        _showing = false;
      }; // Handle toggling visibility areas


      if ($scope.show) {
        _open();
      }

      $scope.$watch('show', function (showingChange) {
        if (showingChange) {
          _open();
        } else if (!showingChange && _showing) {
          $scope.hideModal();
        }
      });
      $scope.$on('$destroy', function () {
        if (_showing) {
          $scope.hideModal();
        }
      });
    },
    template: '\
        <div class="modal" ng-class="{\'modal-visible\': show}">\
            <div class="modal-content-container">\
                <div class="modal-close-icon" ng-click="hideModal()" ng-if="canClose !== false" compass-action="close-modal"><icon name="x"></icon></div>\
                <div class="modal-inner-content-wrapper">\
                    <div class="modal-inner-content-container">\
                        <ng-transclude></ng-transclude>\
                    </div>\
                </div>\
            </div>\
        </div>'
  };
}).directive('modalActions', function () {
  return {
    // only <modal>...</modal> allowed
    restrict: 'E',
    scope: {},
    // replace the outerHTML with our generated content
    replace: true,
    // insert the innerHTML into our template wrapper
    transclude: true,
    template: '<div class="modal-actions"><ng-transclude></ng-transclude></div>'
  };
});